import { render } from "./animauxDetails.vue?vue&type=template&id=7df32a5a&scoped=true"
import script from "./animauxDetails.vue?vue&type=script&lang=js"
export * from "./animauxDetails.vue?vue&type=script&lang=js"

import "../assets/css/animauxdetails.css?vue&type=style&index=0&id=7df32a5a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df32a5a"]])

export default __exports__